export default __webpack_public_path__ + "static/media/Youtube.dfa3f129.svg";